// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const BannerVendi: React.FC = () => {
  const { t } = useTranslation();

  const buttonText = t('homePage.sellBanner.cta');

  return (
    <section id="bannerVendi" className="space-ptb bg-gradient-blue">
      <div className="container">
        <div className="row justify-content-around align-items-center">
          <div className="d-none d-md-block col-md-6 col-lg-4">
            <img className="img-fluid" src="../assets/images/home/locandinaGuida.jpg" alt={`${t('homePage.sellBanner.sellHomeAlt')}`} />
          </div>
          <div className="col-12 col-md-6 text-center">
            <div className="section-title">
              <h2 className="text-white mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }}></h2>
              <p className="text-white">{t('homePage.sellBanner.para1')}</p>
            </div>
            <Link className="btn btn-primary mb-2 mb-sm-0" to="/vendi-casa" title={buttonText}>
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerVendi;